import { render } from "./선원검진.vue?vue&type=template&id=050d9e61"
import script from "./선원검진.vue?vue&type=script&lang=js"
export * from "./선원검진.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__